import SectionHeading from "./SectionHeading";
import { guides, guideNotes } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="06"
          eyebrow="How To Browse"
          title="收录守则 · 四步翻完全记录"
          desc="本站只做图集信息归档与索引展示，所有内容按人物与事件分类整理。照着下面四步走，基本能覆盖大多数浏览场景。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guides.map((item) => (
            <div key={item.step} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">{item.step}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-secondary-200 bg-secondary-50 p-6">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-shield-check-line text-lg"></i>
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-950">浏览与收录说明</h3>
          </div>
          <ul className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-3">
            {guideNotes.map((note) => (
              <li key={note} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-secondary-500"></i>
                <span>{note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}